export default {
    documents: {
        title: '文档',
        loading: '加载中...',
        retry: '重试',
        noDocuments: '暂无文档',
        createFirst: '创建你的第一个文档',

        // Document types
        types: {
            disclosure: '技术交底书',
            patent_draft: '专利文稿',
            prosecution: '答复文件',
            patent_claim: '权利要求',
            specification: '说明书',
            rejection_comparison: '驳回对比',
            technical_doc: '技术文档',
            other: '其他',
        },

        // Time formatting
        time: {
            today: '今天',
            yesterday: '昨天',
            daysAgo: '{count} 天前',
        },

        // Actions
        actions: {
            delete: '删除',
            edit: '编辑',
            download: '下载',
            open: '打开',
        },

        // Rename dialog
        rename: {
            title: '修改文档名称',
            confirm: '保存',
            cancel: '取消',
            inputErrorMessage: '请输入文档名称',
        },

        // Content preview
        preview: {
            noContent: '暂无内容',
            wordCount: '{count} 字',
        },

        // Delete confirmation
        deleteConfirm: {
            title: '删除文档',
            message: '确定要删除"{title}"吗？',
            confirm: '删除',
            cancel: '取消',
        },

        // Messages
        deleteSuccess: '文档删除成功',
        renameSuccess: '文档名称修改成功',
        downloadSuccess: '文档下载成功',

        // Errors
        errors: {
            loadFailed: '加载文档失败',
            openFailed: '打开文档失败',
            deleteFailed: '删除文档失败',
            renameFailed: '修改文档名称失败',
            downloadFailed: '下载文档失败',
        },
    },
};
